$(document).ready(function() {

  
  

  $('#MainContent section').each(function(){
    if($(this).find('.video-bg').length){
      $(this).addClass('overflow_auto');
    }
  })
  // Full page scroll js
  if($('body').hasClass('temp_index')){
    $('#MainContent').fullpage({
        autoScrolling:true,
        scrollingSpeed: 500,
        lazyLoading: true
    });
  }
  
  // Mega menu scroll
  $('.menu_mega_cstm .side_mega').hover(
    function() {
      $.fn.fullpage.setAutoScrolling(false);
      $('body').css('overflow', 'hidden');
    },
    function() {
      $.fn.fullpage.setAutoScrolling(true);
    }
  );

  
function check_open_menu(){
  $('.cstm_list-menu li.first_step').each(function(){
   var sum_aria = $(this).find('.cstm_summary').attr('aria-expanded');
    if(sum_aria == "true" ){
      $('body').addClass('menu_open');
      return false;
    }else{
      $('body').removeClass('menu_open');
    }
  });
}

    // Main menu hover open menu js
  $('.header__inline-menu .list-menu li').on('mouseenter', function(){
    $(this).find('.header__menu-item').attr('aria-expanded', 'true');
     $(this).find('details').attr('open', true);
     check_open_menu();
  });
    $('.header__inline-menu .list-menu li').on('mouseleave', function(){
    $(this).find('.header__menu-item').attr('aria-expanded', 'false');
     $(this).find('details').removeAttr('open');
     check_open_menu();
  });

  // Product page slider
  if($('.swiper_thumb').is(':visible')){
    var galleryThumbs = new Swiper('.swiper_thumb', {
      spaceBetween: 30,
      slidesPerView: 4,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: '.swiper_thumb .swiper-button-next',
        prevEl: '.swiper_thumb .swiper-button-prev',
      },
    });
    var galleryTop = new Swiper('.swiper_main', {
      spaceBetween: 0,
      // navigation: {
      //   nextEl: '.swiper_main .swiper-button-next',
      //   prevEl: '.swiper_main .swiper-button-prev',
      // },
      thumbs: {
        swiper: galleryThumbs
      }
    });
  }else{
      var galleryTop = new Swiper('.swiper_main', {
      spaceBetween: 0,
      pagination: {
        el: '.swiper_main .slider__pagination',
        clickable: true,
      },
      // navigation: {
      //   nextEl: '.swiper_main .swiper-button-next',
      //   prevEl: '.swiper_main .swiper-button-prev',
      // }
    });
  }
  var metaThumbs = new Swiper('.meta_img_thumb_main', {
      spaceBetween: 30,
      slidesPerView: 4,
      navigation: {
        nextEl: '.meta_img_thumb_main .swiper-button-next',
        prevEl: '.meta_img_thumb_main .swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        500: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1000: {
          slidesPerView: 4,
        }
      }
    });
  // Product page js
  
  var input_Color = $("input[name='Acryl Color']:checked").val();
  var input_Style = $("input[name='Style']:checked").val();
  $("input[name='Acryl Color']").closest('.product-form__input').find('.sel_variant').text(input_Color);
  $("input[name='Style']").closest('.product-form__input').find('.sel_variant').text(input_Style);

  $('.cstm_input').on('change', function(){
     var input_name = $(this).attr('name');
    var input_Color = $("input[name='" +input_name+ "']:checked").val();
    $(this).closest('.product-form__input').find('.sel_variant').text(input_Color);
    // change price
    /*setTimeout(()=>{
      $(".cstm-btn").load(location.href+" .cstm-btn>*","");
    },100);*/

    setTimeout(() => {
  $(".cstm-btn").html($(location).find(".cstm-btn").html());
      var defaultprice = $('.prod_details .price--on-sale .price__sale .price-item--last').text();
      $('.cstm-btn .price-item--last').text(defaultprice);

      var saleprice = $('.prod_details .price--on-sale .price__sale .price-item--regular').text();
       $('.cstm-btn .price-item--regular').text(saleprice);
}, 400);

    
  });

  // hide multirow
  if($('.multirow .multirow__inner').is(':empty')){
    $('.multirow__inner').closest('.multirow').hide();
  }
  if($('.metafiled_media')[0]){
    $('body').addClass('has_bnr');
  }

  // Popup js
  function show_popup(){
    $(".itg_popup_wr").addClass("visible");
    $("body").addClass('hide_scroll');
    if($('body').hasClass('temp_index')){
      $.fn.fullpage.setAutoScrolling(false);
    }
  }
  $(document).on("click", ".announcement-bar__message a", function (e) {
    e.preventDefault();
    show_popup();
  });
  $(document).on("click", ".itg_close_btn, .itg_popup_overlay", function () {
    $(".itg_popup_wr").removeClass("visible");
    $("body").removeClass('hide_scroll');
    if($('body').hasClass('temp_index')){
      $.fn.fullpage.setAutoScrolling(true);
    }
    // localStorage.setItem('popup_close', "true");
  });

  var get_localStorage = localStorage.getItem('popup_close');
  if($('body').hasClass('temp_index')){
    show_popup();
  }
  
  // if(get_localStorage == "true"){
  // }else{
  //   show_popup();
  // }

  // Product Page Show Hide
  $(document).find('.readmore').each(function(){
   var div_height = $(this).siblings('.product-single__description').innerHeight();
    if(div_height < 80){
      $(this).hide();
    }
  });

  $('.readmore').click(function (event) {
      event.preventDefault();
      $(this).parents('.product-description-container').toggleClass('remove');
      $(this).text($(this).text() == 'Read less' ? '...Read More' : 'Read less');
  });

  // Checkout page js
  $(document).on('click', '[name="checkout"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });

  // on click menu change
  if(location.href.includes('general-features')){
    $('.list-menu__item').on('click', function(){
      var text = $(this).text().trim().toLowerCase().replace(/ /g,'-');
      $('.sidebar_other ul li').each(function(){
        var data_value = $(this).data('value');
        if(text == data_value){
          $(this).find('a').click();
        }
      })
    });
  }

  // product description js 

  $(".main_div_description h2").click(function(){
    $(this).parents(".main_div_description").toggleClass("actives_plus");
    $(".hide_product_descriptions").slideToggle("slow");
  });

  announce_slider();
  $(window).on('resize', function(){
    announce_slider();
  });
  function announce_slider(){
    if ($(window).outerWidth() < 750 && $('body').hasClass('temp_product')) {
      $(".main_div_description").addClass('actives_plus');
    }else{
      //$(".main_div_description").removeClass('actives_plus');
       $(".main_div_description").addClass('actives_plus');
    }
  }
});
